import { render } from "./TableOfContents.vue?vue&type=template&id=6b93dfa9&scoped=true"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=6b93dfa9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b93dfa9"]])

export default __exports__